import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";
import useUserStore from "../store/userStore";
import useTokenLogin from "../hooks/useTokenLogin";
import { useEffect } from "react";

function Layout() {
  const token = useUserStore((state) => state.token);
  const setToken = useUserStore((state) => state.setToken);
  const { mutate, isPending } = useTokenLogin();

  useEffect(() => {
    if (!token) {
      const localToken = localStorage.getItem("token");
      if (localToken) {
        mutate(localToken, {
          onSuccess: (data) => {
            setToken(data);
          },
          onError: () => {
            localStorage.removeItem("token");
          },
        });
      }
    }
  }, [token, mutate, setToken]);

  if (isPending) return <>Loading...</>;

  return (
    <>
      <NavBar />
      <Outlet />
    </>
  );
}

export default Layout;
